// Mock data for Lxdia

export const brandLogos = [
  { name: 'Tata Motors', logo: 'https://logo.clearbit.com/tatamotors.com' },
  { name: 'WhatsApp Business', logo: 'https://logo.clearbit.com/whatsapp.com' },
  { name: 'PhysicsWallah', logo: 'https://logo.clearbit.com/pw.live' },
  { name: 'LPU University', logo: 'https://logo.clearbit.com/lpu.in' },
  { name: 'Seekho App', logo: 'https://logo.clearbit.com/seekho.ai' },
  { name: 'Slice', logo: 'https://logo.clearbit.com/sliceit.com' },
  { name: 'Shadowfax', logo: 'https://logo.clearbit.com/shadowfax.in' },
  { name: 'Odoo', logo: 'https://logo.clearbit.com/odoo.com' },
  { name: 'Amazon', logo: 'https://logo.clearbit.com/amazon.com' },
  { name: 'Policybazaar', logo: 'https://logo.clearbit.com/policybazaar.com' }
];

export const productFeatures = [
  {
    id: 'influencer-marketing',
    icon: '💡',
    title: 'Influencer Marketing',
    tagline: 'Real creators. Real reach. Real results.',
    description: 'We connect your brand with the right creators who truly influence your audience.',
    points: [
      'We connect your brand with the right creators who truly influence your audience.',
      'Data-driven influencer selection ensures maximum ROI.',
      'From strategy to reporting — we handle your campaigns end-to-end.',
      '100% transparent communication and measurable performance tracking.',
      'Content that feels natural, not forced — so engagement is genuine.',
      'Proven track record with leading brands across multiple industries.'
    ],
    link: '/services/influencer-marketing',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800'
  },
  {
    id: 'talent-management',
    icon: '💫',
    title: 'Talent Management',
    tagline: 'Building brands out of creators.',
    description: 'We represent creators and help them build long-term brand value.',
    points: [
      'We represent creators and help them build long-term brand value.',
      'From negotiations to contracts — we handle everything professionally.',
      'Personalized career planning and brand collaborations that fit your niche.',
      'Strong PR and networking support to grow your digital presence.',
      'Dedicated team to manage campaigns, payments, and deliverables.',
      'We don\'t just manage — we help you become a brand.'
    ],
    link: '/services/talent-management',
    image: 'https://images.unsplash.com/photo-1552581234-26160f608093?w=800'
  },
  {
    id: 'public-relations',
    icon: '📰',
    title: 'Public Relations (PR)',
    tagline: 'Crafting stories that make headlines.',
    description: 'We help brands get featured across top media and digital platforms.',
    points: [
      'We help brands get featured across top media and digital platforms.',
      'Strategic storytelling that positions your brand as an authority.',
      'Strong media relations to get you organic visibility and credibility.',
      'Press releases, interviews, and event coverage — all under one roof.',
      'Reputation management that builds trust with your audience.',
      'PR campaigns tailored to create real public impact, not just noise.'
    ],
    link: '/services/public-relations',
    image: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=800'
  },
  {
    id: 'performance-marketing',
    icon: '📈',
    title: 'Performance Marketing',
    tagline: 'Every click counts, every rupee performs.',
    description: 'Data-backed ad strategies focused on conversions, not just clicks.',
    points: [
      'Data-backed ad strategies focused on conversions, not just clicks.',
      'We combine creativity with analytics to maximize ROI.',
      'Real-time performance tracking and campaign optimization.',
      'Expertise across Meta, Google, YouTube, and influencer-led ads.',
      'Transparent reporting so you see where every penny goes.',
      'Drive measurable results — more traffic, leads, and sales.'
    ],
    link: '/services/performance-marketing',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800'
  }
];

export const bonusFeatures = [
  {
    title: 'End-to-end campaign management',
    description: 'From strategy to execution and reporting, we handle everything so you can focus on your business.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400',
    size: 'medium'
  },
  {
    title: 'Creator partnerships that convert',
    description: 'We connect you with authentic creators whose audience aligns perfectly with your brand.',
    image: 'https://images.pexels.com/photos/7667442/pexels-photo-7667442.jpeg?w=400',
    size: 'large'
  },
  {
    title: 'Performance-driven results',
    description: 'Every campaign is optimized for maximum ROI with transparent metrics.',
    image: null,
    size: 'small'
  },
  {
    title: 'Multi-platform expertise',
    description: 'From Instagram and YouTube to LinkedIn and emerging platforms, we know where your audience is.',
    image: 'https://images.unsplash.com/photo-1560769629-975ec94e6a86?w=400',
    size: 'medium'
  },
  {
    title: 'Content that feels natural',
    description: 'No forced ads. Just genuine content that resonates with your target audience.',
    image: 'https://images.unsplash.com/photo-1492707892479-7bc8d5a4ee93?w=400',
    size: 'small'
  },
  {
    title: 'Proven track record',
    description: 'Trusted by leading brands across industries to deliver measurable growth.',
    image: null,
    size: 'medium'
  }
];

export const testimonials = [
  {
    id: 1,
    company: 'Wigiwama',
    companyLogo: 'https://logo.clearbit.com/wigiwama.com',
    quote: 'Lxdia transformed our influencer marketing strategy. Their team handled everything from creator selection to performance tracking, delivering results beyond our expectations.',
    author: 'Regina Kacajeva',
    role: 'Creator Partnerships Manager',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400'
  },
  {
    id: 2,
    company: 'Burga',
    companyLogo: 'https://logo.clearbit.com/burga.com',
    quote: 'The talent management service is exceptional. They helped our creators build authentic brands while maintaining professional relationships with sponsors.',
    author: 'Rugile Paleviciute',
    role: 'Head of Global Partnerships',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400'
  },
  {
    id: 3,
    company: 'Regal Rose',
    companyLogo: 'https://logo.clearbit.com/regalrose.co.uk',
    quote: 'Their PR team got us featured in top publications we never thought possible. The media coverage significantly boosted our brand credibility.',
    author: 'Ayme Mendes Da Costa',
    role: 'Marketing Manager',
    image: 'https://images.unsplash.com/photo-1581065178047-8ee15951ede6?w=400'
  },
  {
    id: 4,
    company: 'NordVPN',
    companyLogo: 'https://logo.clearbit.com/nordvpn.com',
    quote: 'The performance marketing campaigns delivered exceptional ROI. Their data-driven approach and transparent reporting made all the difference.',
    author: 'Laura Garsdal',
    role: 'Digital Marketing Lead',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400'
  },
  {
    id: 5,
    company: 'Trendhim',
    companyLogo: 'https://logo.clearbit.com/trendhim.com',
    quote: 'Working with Lxdia feels like having an extended team. They understand our goals and consistently deliver campaigns that drive real business results.',
    author: 'Maris Niilus',
    role: 'Brand Partnerships Director',
    image: 'https://images.pexels.com/photos/34534596/pexels-photo-34534596.jpeg?w=400'
  }
];

export const faqData = [
  {
    id: 1,
    question: 'What services does Lxdia offer?',
    answer: 'Lxdia offers four core services: Influencer Marketing (connecting brands with the right creators), Talent Management (representing creators and building their brand value), Public Relations (getting brands featured in top media), and Performance Marketing (data-driven ad campaigns focused on conversions).'
  },
  {
    id: 2,
    question: 'How do you select influencers for campaigns?',
    answer: 'We use a data-driven approach to select influencers based on audience demographics, engagement rates, past performance, and brand alignment. Every creator is vetted to ensure they truly influence your target audience and can deliver measurable results.'
  },
  {
    id: 3,
    question: 'Do you work with both brands and creators?',
    answer: 'Yes! We work with brands through our Influencer Marketing, PR, and Performance Marketing services. We also represent individual creators through our Talent Management service, helping them build long-term brand value and secure the right partnerships.'
  },
  {
    id: 4,
    question: 'What platforms do you specialize in?',
    answer: 'We have expertise across all major platforms including Instagram, YouTube, TikTok, LinkedIn, Meta (Facebook), Google Ads, and emerging social platforms. We recommend the best platform mix based on where your target audience is most active.'
  },
  {
    id: 5,
    question: 'How do you measure campaign success?',
    answer: 'We track comprehensive metrics including engagement rates, reach, conversions, ROI, brand sentiment, and sales attribution. All campaigns come with transparent reporting so you can see exactly where your investment is going and the results being delivered.'
  },
  {
    id: 6,
    question: 'What industries do you work with?',
    answer: 'We have a proven track record across multiple industries including fashion, beauty, technology, lifestyle, e-commerce, SaaS, healthcare, and more. Our team adapts strategies based on your specific industry dynamics and target audience.'
  }
];

export const painPoints = [
  'Struggling to find the right influencers for your brand?',
  'Need authentic creator partnerships that actually convert?',
  'Want media coverage but don\'t know where to start?',
  'Looking for ad campaigns that deliver measurable ROI?'
];
